import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import classNames from "classnames";
import { memo } from "react";
export const PanelTabButton = /*#__PURE__*/ memo((param)=>{
    let { icon, isSelected, label, pillCount, onClick, testId } = param;
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: label,
        side: "left",
        children: /*#__PURE__*/ _jsxs("button", {
            className: classNames("relative mb-6 flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-lg text-grey-12 transition-colors", isSelected ? "bg-grey-6 hover:bg-grey-7" : "bg-grey-3 hover:bg-grey-4"),
            "data-testid": testId,
            onClick: onClick,
            children: [
                icon,
                !!pillCount && /*#__PURE__*/ _jsx("div", {
                    className: "absolute -right-0.5 -top-0.5 z-[2] flex items-center justify-center rounded-lg bg-red-9 px-1 py-0.5 text-8 font-bold uppercase tracking-wider text-white",
                    children: pillCount
                })
            ]
        })
    });
});
PanelTabButton.displayName = "PanelTabButton";
